import styled from "styled-components";

export const FilterCategoriesListContainerDefaultBox = styled.div`
    display: flex;
    flex-direction: column;
    width: 100%;
    padding: 10px;
    user-select: none;
    overflow-y: auto;
`;